<i18n>
    {
        "de": {
            "faq_and_troubleshooting": "Häufige Fragen und Fehlerbehebung",
            "faq_explanation": "Hier werden häufig gestellte Fragen und Probleme zum Netzwerk veröffentlicht. Sollten dennoch Fragen bestehen, können diese an die folgende E-Mail-Adresse gestellt werden:",
            "categories":[
                {
                    "category":"WLAN",
                    "questions": [
                        {
                            "q":"Ist das öffentliche WLAN in meinem Wohnheim verfügbar?",
                            "a":["Die Verfügbarkeit des WLANs kann unter folgendem Link eingesehen werden (Anmeldung erforderlich):"],
                            "link":{"url":"/wifi", "text":"Verfügbarkeit einsehen"}
                        },
                        {
                            "q":"Darf ich einen eigenen WLAN Router betreiben?",
                            "a":["In Wohnheimen mit voller WLAN-Verfügbarkeit: Nein, da der Betrieb eigener WLAN Access-Points das zentrale WLAN beeinträchtigt."]
                        },
                        {
                           "q":"Mein Gerät sieht das WLAN 'SW-KA' nicht oder kann sich nicht verbinden!",
                           "a":["Leider unterstützen manche Geräte wie z.B. Chromecasts oder Amazon Echos nicht das verwendete Authentifizierungsverfahren mit Nutzernamen und Passwort (802.1X). Hierzu können Sie das Netzwerk SW-KA-IoT verwenden. Dazu müssen Sie die MAC-Addresse des Gerätes in Ihrem Account hinterlegen."],
                          "link":{"url":"/account/mpsk", "text":"Wietere Infos & Einstellungen SW-KA-IoT"}
                        }
                    ]
                },
                {
                    "category":"Internet",
                    "questions": [
                        {
                            "q":"Ich brauche eine Portfreischaltung. Geht das?",
                            "a":["Es ist aktuell leider nicht möglich, Portfreischaltungen vom Internet aus einzurichten. Es ist jedoch in Planung, eine einfache Portfreischaltung auf IPv6 Adressen zu ermöglichen."]
                        },
                        {
                            "q":"Wie sind die Zimmer angebunden?",
                            "a":[
                                "Jedes Zimmer ist mit 100 Mbit Ethernet angebunden. Das Wohnheim selbst ist mit 1 Gigabit Glasfaser an das SCC des KIT angebunden.",
                                "Jedes Zimmer erhät ein /27 Subnetz IPv4 (also 29 nutzbare Adressen), die über DHCP zugewiesen werden, sowie ein /64 IPv6 Netz."
                            ]
                        },
                        {
                            "q":"Gigabit im Zimmer",
                            "a":[
                                "Es ist kein expliziter Zeitpunkt für eine Umrüstung auf Gigabit geplant. Jegliche neu angeschaffte Netzinfrastruktur ist jedoch 1G/10G, d.h. bei Erneuerung der Switche kommt automatisch Gigabit, falls die Verkabelung es erlaubt.",
                                "10G in die Zimmer liegt in sehr weiter Zukunft, da die dafür nötigen Switche extrem teuer (ca. 10x teuerer) sind, und die Kosten der Internetversorung im Mietpreis gering bleiben sollen."
                            ]
                        },
                        {
                            "q":"Speicherung von Daten",
                            "a":[
                                "Aufgrund der Infrastruktur des Studierendenwerks wird nur die Vergabe der IP-Adressen durch den DHCP Server im normalen Log protokolliert. Dies erfasst die Daten der Mac-Adresse, des Host-Identifier (von ihrem Gerät gesendet), der vergebene IP-Adresse und dem Zeitpunkt. Diese Daten dienen der technischen Fehlerbehebung, und werden nach maximal 7 Tagen automatisch gelöscht.",
                                "Unser Monitoring System speichert zudem die Portauslastung (Unicast-, Multicast / Broadcast / Errors / Drops) jedes Switchports im 5-Minuten-Averaging auf. Diese Daten dienen ebenfalls der Fehleranalyse.", "Im SCC werden Netflow-Daten auf dem Router vor und hinter der Firewall (IPv4-NAT) erhoben und ca. 7 Tage lang gespeichert. Nur das CERT des KIT hat auf diese Daten Zugriff. Diese Informationen beinhalten u.a. Portnummern und Verbindungsziele."
                            ]
                        },
                        {
                            "q":"Nutzung VPN",
                            "a":[
                                "Laut Mietvertrag gilt: 'Das Benutzen anderer IP-Adressen ist verboten; das kann zum Ausschluss von der Internet-Nutzung und zur Kündigung des Mietvertrags führen.'",
                                "Im Falle eines VPN-Tunnels wird in unserem Netz keine fremde IP-Adresse benutzt, d.h. unsere Router sehen nur die ihnen zugewiesenen. Für uns sind die IP-Adressen der Firma durch die (hoffentlich vorhandene) Verschlüsselung nicht sichtbar.",
                                "Wenn Sie ihrem PC statisch nun einen IP-Adresse eines anderen Bewohners geben würden, und damit z.B. UDP Pakete an andere Systeme senden (z.B. um einen DoS-Angriff durchzuführen), wäre dies ein Verstoß gegen diese Klausel. Die Antwortpakete kämen bei ihnen jedoch nicht an, d.h. normale Internetnutzung ist nicht möglich. Wir haben auch technische Maßnahmen ergriffen, die IP-Spoofing verhindern, d.h. nur der eigene Internetzugriff ist dann gestört."
                            ]
                        },
			{
			   "q": "Verbindungsprobleme mit (managed) Switches",
			   "a": ["Bitte achten Sie daraf, Spanning-Tree (STP) auf dem Switch zu deaktivieren. Dies kann zur automatischen (temporären) Blockierung Ihres Anschlusses führen.", "In einigen Wohnheimen stehen aufgrund der Verkabelung nur 100Mbit/s bei den kabelgebunden Anschlüssen in Zimmern zur verfügung. Dies kann bei der Verwendung einiger managed Switches zu Problemen mit der automatischen Verbindungsaushandlung führen. Hierbei kann es helfen, Auto-Negotiation zu deaktivieren und den Port fest auf 100Mbit/s zu konfigurieren."]
			}
                    ]
                },
                {
                    "category":"Account",
                    "questions": [
                        {
                            "q":"Ich habe mein Passwort vergessen",
                            "a":[
                                "Unter dem folgenden Link kann das Passwort zurückgesetzt werden.",
                                "Nachdem Sie die hinterlegte E-Mail-Adresse angegeben haben, erhalten Sie eine E-Mail mit allen weiteren Schritten zur Änderung Ihres Passwortes."],
                            "link":{"url":"/account/forgot", "text":"Passwort zurücksetzen"}
                        },
                        {
                            "q":"Wie ändere ich mein Passwort / meine E-Mail-Adresse?",
                            "a":["Unter folgendem Link kann das Passwort bzw. die E-Mail-Adresse geändert werden:"],
                            "link":{"url":"/account", "text":"Account bearbeiten"}
                        }
                    ]
                }
            ]
        },
        "en": {
            "faq_and_troubleshooting": "FAQ & Troubleshooting",
            "faq_explanation": "Answers to common problems and questions are published here. If your problem is not answered here, write to the following e-mail.",
          "categories":[
                {
                    "category":"Wi-Fi",
                    "questions": [
                        {
                            "q":"Is the public WiFi available in my dormitory?",
                            "a":["The availability of the dormitory WiFi can be checked under the following link:"],
                            "link":{"url":"/wifi", "text":"Check availability"}
                        },
                        {
                            "q":"May I operate my own WiFi router?",
                            "a":["In dormitories with full WiFi availability: No, because operating your own WiFi access points interferes with the central WiFi system."]
                        },
                        {
                           "q":"My device does not find the wireless network 'SW-KA' or is unable to connect!",
                           "a":["Unfortunately, some devices do not support the authentication method used for SW-KA (username and password, 802.1X). You can use the wireless network SW-KA-IoT instead."],
                           "link":{"url":"/account/mpsk", "text":"Further information and settings for SW-KA-IoT"}
                        }
                    ]
                },
                {
                    "category":"Internet",
                    "questions": [
                        {
                            "q":"I need a port activation. Is this possible?",
                            "a":["It is currently not possible to set up a port activation from the Internet. However, it is planned to enable a simple port activation via IPv6 addresses in the future."]
                        },
                        {
                            "q":"How are the rooms connected to the internet?",
                            "a":[
                                "Each room is connected through a 100 Mbit Ethernet connection. The dormitory itself is connected to the KIT SCC via 1 Gbit optical fiber.",
                                "Each room has a /27 IPv4 network (29 usable addresses) assigned via DHCP and a /64 IPv6 network."
                            ]
                        },
                        {
                            "q":"Gigabit in my room",
                            "a":[
                                "There is no explicit date planned for an upgrade to Gigabit. However, any newly purchased network infrastructure is 1G/10G, i.e. when the switches are replaced, Gigabit will automatically be added if the infrastructure allows it.",
                                "Adding 10G to the rooms is in the very distant future, as the switches required for this are extremely expensive (about 10 times more expensive), and the costs for Internet access should remain low in the rental price."
                            ]
                        },
                        {
                            "q":"Storage of data",
                            "a":[
                                "Due to the infrastructure of the Studierendenwerk, only the assigned IP addresses by the DHCP server are logged in the normal log. This includes the data of the Mac address, the host identifier (sent by your device), the assigned IP address and the time. The data is used for technical troubleshooting, and is automatically deleted after a maximum of 7 days.",
                                "Our monitoring system also stores the port usage (unicast, multicast / broadcast / errors / drops) of each switch port in 5-minute averaging. This data is also used for error analysis.", "In SCC, Netflow data is collected at the router in front of and behind the firewall (IPv4-NAT) and stored for about 7 days. Only the KIT CERT has access to this information. This includes information such as port numbers and connection destinations."
                            ]
                        },
                        {
                            "q":"Use of VPN",
                            "a":["According to the lease agreement, 'The use of other IP addresses is prohibited; this can lead to the exclusion from Internet use and the termination of the lease'.", "In the case of a VPN tunnel, no other IP address is used in our network, i.e. our routers only see the addresses assigned to them. For us, the IP addresses of the company are not visible due to the (hopefully existing) encryption.", "If, in theory, you would now statically give your PC an IP address of another resident, and thus send e.g. UDP packets to other systems (e.g. to carry out a DoS attack), this would be a violation of this clause. However, the response packets would not reach them, i.e. normal Internet use is not possible. We have also taken technical measures to prevent IP spoofing, i.e. only your own Internet access is then disrupted."]
                        },
			{
			   "q": "Connection problems with (managed) Switches",
			   "a": ["Please make sure to disable spanning tree (STP) in your switch. STP can temporarily block your port.", "In some dormitories, only 100Mbit/s is available for the wired connections in rooms due to the cabling. This can lead to problems with automatic connection negotiation when using some managed switches. Please disable auto-negotiation and configure the port permanently to 100Mbit/s to mitigate this issue."]
			}
                    ]
                },
                {
                    "category":"Account",
                    "questions": [
                        {
                            "q":"I forgot my password",
                            "a":[
                                "The password can be reset via the following link.",
                                "After you have entered your e-mail address, you will receive an e-mail with all further instructions to change your password."
                            ],
                            "link":{"url":"/account/forgot", "text":"Reset password"}
                        },
                        {
                            "q":"How do I change my password / e-mail address?",
                            "a":["Under the following link you can change your password or your e-mail address:"],
                            "link":{"url":"/account", "text":"Edit Account"}
                        }
                    ]
                }
            ]
        }
    }
</i18n>
<template>
    <div id="faq">
        <h1>{{ $t('faq_and_troubleshooting') }}</h1>
        <p>
            {{ $t('faq_explanation') }}
            <br>
            <b-link href="mailto:support-wh-netze@sw-ka.de">support-wh-netze@sw-ka.de</b-link>
        </p>

        <div v-for="(category, index_1) in $t('categories')" v-bind:key="category">
            <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle="'accordion-' + index_1" variant="outline-dark">{{ category['category'] }}</b-button>
                    </b-card-header>
                    <b-collapse :id="'accordion-' + index_1" accordion="my-accordion" role="tabpanel">
                        <div v-for="(question, index_2) in category['questions']" v-bind:key="question">
                            <b-card-body>
                                <b-card no-body class="mb-1">
                                    <b-card-header header-tag="header" class="p-1" role="tab">
                                        <b-button block v-b-toggle="'accordion-' + index_1 + '-' + index_2" variant="outline-primary">{{ question['q'] }}</b-button>
                                    </b-card-header>
                                    <b-collapse :id="'accordion-' + index_1 + '-' + index_2" accordion="my-nested-accordion" role="tabpanel">
                                        <b-card-body>
                                            <b-card-text>
                                                <p v-for="phrase in question['a']" v-bind:key="phrase">{{ phrase }}</p>
                                            </b-card-text>
                                            <b-card-text v-if="question['link']"><b-link v-if="!question['link']['url'].includes('http')" :to="question['link']['url']">{{ question['link']['text'] }}</b-link><b-link v-else target="_blank" :href="question['link']['url']">{{ question['link']['text'] }}</b-link></b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </b-card-body>
                        </div>
                    </b-collapse>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "faq"
    }
</script>

<style scoped>

</style>
